import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propBool, propFunc, propStr } from '../../../helpers/custom-prop-types';
const CancelButton = ({ className, isDisabled, onClick, text }) => (_jsx("button", Object.assign({ className: className, disabled: isDisabled, onClick: (e) => {
        e.preventDefault();
        onClick();
    }, type: 'button' }, { children: text })));
CancelButton.propTypes = {
    className: propStr(),
    isDisabled: propBool(),
    onClick: propFunc().isRequired,
    text: propStr(),
};
CancelButton.defaultProps = {
    className: 'btn btn-tertiary',
    isDisabled: false,
    text: 'キャンセル',
};
export default CancelButton;
